import groq from 'groq';

import { ASSET, ASSET_DECORATIVE } from '../common';

const BACKGROUND = groq`
  backgroundImage {
    ${ASSET_DECORATIVE}
  }
`;

const THUMBNAIL = groq`
  thumbnailImage {
    ${ASSET}
  },
  backgroundColor {
    hex 
  }
`;

export const ONWARDS_5050 = groq`
  cards[] {
    title,
    subtitle,
    "media": select(
      defined(thumbnailImage) => { ${THUMBNAIL} },
      defined(backgroundImage) => { ${BACKGROUND} },
      null
    ),
    cta {
      title,
      href
    }
  }
`;

export const ONWARDS_5050_BLOCK = groq`
  _type == 'timeline_onwards5050' => {
    ${ONWARDS_5050}
  }
`;
